// views/Ticketing/TicketOrdersRedirect.js
// ─────────────────────────────────────────────────────────────────────────────
// Ticketing > Ticket orders: the orders list, narrowed to ticket orders
// (16 Oct 2026). One list for every order, so a ticket order is found, sorted,
// totalled and exported the same way as any other; the `ticket` filter
// (server: utils/orderListFilters.js ticketStateClause) and each row's ticket
// stage make it a ticket list. The menu badge beside this item counts the
// ticket orders that need a person.
// ─────────────────────────────────────────────────────────────────────────────

import React from "react";
import { Redirect } from "react-router-dom";
import { ordersLink } from "../../utilities/orderDeepLinks";

const TicketOrdersRedirect = () => <Redirect to={ordersLink("admin", { ticket: "all" })} />;

export default TicketOrdersRedirect;
